import './profile.common';

import languagesBox from './features/language-box';

// Show all languages
languagesBox('click');
